define.alias("checkout/components/seamless-checkout/checkout-success-modal", "calendar/components/seamless-checkout/checkout-success-modal");